/**
 * en-GB messages added by Phase 2 task S10 (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s10EnGB = {
    'nav.webhooks': 'Webhooks',
    'email.webhooks.endpoint_failing.subject': 'Webhook not working: {endpoint}',
    'email.webhooks.endpoint_failing.body': '{tenant}: CloudSign has not been able to deliver webhooks to "{endpoint}" since {since}. We keep trying again automatically. Open the Webhooks page to see each attempt and what the other system replied.',
    'email.webhooks.endpoint_failing.button': 'Open the Webhooks page',
    'email.webhooks.endpoint_recovered.subject': 'Webhook working again: {endpoint}',
    'email.webhooks.endpoint_recovered.body': '{tenant}: webhooks to "{endpoint}" are being delivered again. Nothing is lost: earlier events were sent with their original times.',
    'email.webhooks.endpoint_recovered.button': 'Open the Webhooks page',
    'webhook.error.url_refused': 'This address cannot be used for webhooks. Use a public https address.',
    'webhook.error.managed': 'This webhook is managed by another part of CloudSign and cannot be changed here.',
    'webhook.error.in_progress': 'This delivery is still being sent or waiting for its next try.',
    'webhook.error.payload_cleared': 'The content of this delivery has been cleared, so it cannot be sent again.',
    'webhook.error.endpoint_paused': 'This webhook is paused.',
    'webhook.error.no_endpoint': 'No webhook has been set up for this connection.',
    // Delivery log: why an attempt failed
    'webhook.error.http_status': 'The other system replied with an error.',
    'webhook.error.timeout': 'The other system did not reply in 10 seconds.',
    'webhook.error.connection_failed': 'Could not connect to the other system.',
    'webhook.error.dns_failed': 'The address could not be found.',
    'webhook.error.refused_address': 'The address points to a private or internal network, which webhooks may not use.',
    'webhook.error.invalid_url': 'The address is not valid.',
    'webhook.error.scheme_not_allowed': 'Only https addresses can be used.',
    'webhook.error.port_not_allowed': 'Only the standard secure ports (443 and 8443) can be used.',
    'webhook.error.body_too_large': 'The message was too large to send.',
    'webhook.error.invalid_headers': 'The request could not be built.',
    'webhook.error.internal': 'CloudSign could not send this attempt.',
};
//# sourceMappingURL=s10.js.map